var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { computed, ref, onUnmounted, onMounted } from 'vue';
import { AudioContextWrapper } from '@common/utils/AudioContextWrapper';
import { cloneBlob } from '@common/utils/File/File';
import uniq from 'lodash/uniq';
import Message from '@common/ui/EMessage/Message';
import EIcon from '@common/ui/EIcon.vue';
import { isTouchable } from '@common/utils/Crossbrowser';
import { MediaRecorder, register, deregister } from 'extendable-media-recorder';
import { connect, disconnect } from 'extendable-media-recorder-wav-encoder';
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ERecordAudio',
    props: {
        retention: {
            type: Boolean,
            default: false
        },
    },
    emits: {
        move: function (mouseEvent) { },
        start: function (mouseEvent, info) { },
        stop: function (audioChunks, stopBy, averageFrequency) { },
        send: function (audioChunks, averageFrequency) { }
    },
    setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var timeoutId = null;
        var requestId = null;
        var isRecord = ref(false);
        var holdStartTime = ref(0);
        var sliceFrequency = computed(function () {
            var samples = 100;
            var blockSize = Math.ceil(frequency.value.length / samples);
            var filteredData = [];
            for (var i = 0; i < samples; i++) {
                var blockStart = blockSize * i;
                var sum = 0;
                for (var j = 0; j < blockSize; j++) {
                    sum = sum + Math.abs(frequency.value[blockStart + j]);
                }
                filteredData.push(sum / blockSize);
            }
            return filteredData;
        });
        var frequencyPercent = computed(function () {
            var sort = uniq(sliceFrequency.value).sort(function (a, b) { return a - b; });
            var median = sort.at(Math.ceil(sort.length / 2)) || 1;
            var onePercent = median / 100;
            return sliceFrequency.value.map(function (s) {
                var v = s / onePercent;
                if (!isFinite(v)) {
                    return 0;
                }
                if (v > 100) {
                    return 100;
                }
                return v;
            });
        });
        var volumePx = ref(0);
        var mediaRecorder = ref(null);
        var startTimestamp = ref(null);
        var audioChunk = ref(null);
        var eventAfterAudioAvailable = ref([]);
        var mouseState = ref('off');
        var frequency = ref([]);
        var emits = __emit;
        var props = __props;
        var t = useI18n().t;
        var wavEncoderConnect = ref();
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = wavEncoderConnect;
                        return [4 /*yield*/, connect()];
                    case 1:
                        _a.value = _b.sent();
                        return [4 /*yield*/, register(wavEncoderConnect.value)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        removeListeners();
                        return [4 /*yield*/, deregister(wavEncoderConnect.value)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, disconnect(wavEncoderConnect.value)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        var send = function () {
            stopRecord();
            var cbSend = function () { return __awaiter(_this, void 0, void 0, function () {
                var blob;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!audioChunk.value) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, cloneBlob(audioChunk.value.data)];
                        case 1:
                            blob = (_a.sent());
                            emits('send', blob, __spreadArray([], __read(frequencyPercent.value), false));
                            clearAudio();
                            return [2 /*return*/];
                    }
                });
            }); };
            if (audioChunk.value) {
                cbSend();
                return;
            }
            eventAfterAudioAvailable.value.push(cbSend);
        };
        var manualStop = function (by, clearedAudio) {
            mouseState.value = 'off';
            stopRecord();
            var cbStop = function () { return __awaiter(_this, void 0, void 0, function () {
                var blob;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!audioChunk.value) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, cloneBlob(audioChunk.value.data)];
                        case 1:
                            blob = (_a.sent());
                            emits('stop', blob, by, __spreadArray([], __read(frequencyPercent.value), false));
                            if (clearedAudio) {
                                clearAudio();
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            if (audioChunk.value) {
                cbStop();
                return;
            }
            eventAfterAudioAvailable.value.push(cbStop);
        };
        var recordAudioMobile = function (event) {
            holdStartTime.value = Date.now();
            if (!isTouchable()) {
                return;
            }
            document.addEventListener('touchmove', touchMoveAfterRecordStart);
            document.addEventListener('touchend', touchEndAfterRecordStart);
            startRecord({
                clientX: event.targetTouches[0].clientX,
                clientY: event.targetTouches[0].clientY
            });
        };
        var recordAudioDesktop = function (event) {
            holdStartTime.value = Date.now();
            if (isTouchable()) {
                return;
            }
            mouseState.value = 'hold';
            document.addEventListener('mousemove', mouseMoveAfterRecordStart);
            document.addEventListener('mouseup', mouseUpAfterRecordStart);
            timeoutId = setTimeout(function () {
                if (!mediaRecorder.value && mouseState.value !== 'off') {
                    startRecord({
                        clientY: event.clientY,
                        clientX: event.clientX,
                    });
                }
                else if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = null;
                }
            }, 200);
        };
        var touchMoveAfterRecordStart = function (touchEvent) {
            emits('move', {
                clientX: touchEvent.targetTouches[0].clientX,
                clientY: touchEvent.targetTouches[0].clientY
            });
        };
        var showWarningOnClick = function () {
            var holdDuration = Date.now() - holdStartTime.value;
            if (holdDuration < 200) {
                Message.warning(t('message.recordMessage'));
            }
        };
        var touchEndAfterRecordStart = function () {
            if (props.retention) {
                return;
            }
            send();
        };
        var mouseMoveAfterRecordStart = function (mouseEvent) {
            emits('move', {
                clientX: mouseEvent.clientX,
                clientY: mouseEvent.clientY
            });
        };
        var mouseUpAfterRecordStart = function () {
            mouseState.value = 'off';
            if (props.retention) {
                return;
            }
            send();
        };
        var executeEvents = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, event, e_1_1;
            var _d, e_1, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, 7, 12]);
                        _a = true, _b = __asyncValues(eventAfterAudioAvailable.value);
                        _g.label = 1;
                    case 1: return [4 /*yield*/, _b.next()];
                    case 2:
                        if (!(_c = _g.sent(), _d = _c.done, !_d)) return [3 /*break*/, 5];
                        _f = _c.value;
                        _a = false;
                        event = _f;
                        return [4 /*yield*/, event()];
                    case 3:
                        _g.sent();
                        _g.label = 4;
                    case 4:
                        _a = true;
                        return [3 /*break*/, 1];
                    case 5: return [3 /*break*/, 12];
                    case 6:
                        e_1_1 = _g.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 12];
                    case 7:
                        _g.trys.push([7, , 10, 11]);
                        if (!(!_a && !_d && (_e = _b.return))) return [3 /*break*/, 9];
                        return [4 /*yield*/, _e.call(_b)];
                    case 8:
                        _g.sent();
                        _g.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 11: return [7 /*endfinally*/];
                    case 12:
                        eventAfterAudioAvailable.value.length = 0;
                        return [2 /*return*/];
                }
            });
        }); };
        var startRecord = function (sideEvent) { return __awaiter(_this, void 0, void 0, function () {
            var stream_1, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ audio: true })];
                    case 1:
                        stream_1 = _a.sent();
                        mediaRecorder.value = new MediaRecorder(stream_1, {
                            mimeType: 'audio/wav',
                        });
                        mediaRecorder.value.onstart = function () {
                            mediaRecorderOnStart(stream_1, sideEvent);
                        };
                        mediaRecorder.value.onstop = function () {
                            mediaRecorderOnStop(stream_1);
                        };
                        mediaRecorder.value.ondataavailable = function (blobEvent) {
                            audioChunk.value = blobEvent;
                            executeEvents();
                        };
                        mediaRecorder.value.start();
                        isRecord.value = true;
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error(e_2);
                        Message.error(t('message.microphoneBlocked'));
                        removeListeners();
                        isRecord.value = false;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var mediaRecorderOnStart = function (stream, sideEvent) {
            AudioContextWrapper.stopActiveSource();
            visualize(stream);
            startTimestamp.value = new Date();
            emits('start', sideEvent, {
                date: startTimestamp.value
            });
        };
        var mediaRecorderOnStop = function (stream) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, track;
            var e_3, _c;
            return __generator(this, function (_d) {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = null;
                }
                if (requestId) {
                    cancelAnimationFrame(requestId);
                }
                try {
                    for (_a = __values(stream.getTracks()), _b = _a.next(); !_b.done; _b = _a.next()) {
                        track = _b.value;
                        track.stop();
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                volumePx.value = 0;
                mediaRecorder.value = null;
                startTimestamp.value = null;
                isRecord.value = false;
                AudioContextWrapper.getInstance().audioContext.close();
                removeListeners();
                return [2 /*return*/];
            });
        }); };
        var clearAudio = function () {
            frequency.value.length = 0;
            audioChunk.value = null;
        };
        var stopRecord = function () {
            var _a;
            if (((_a = mediaRecorder.value) === null || _a === void 0 ? void 0 : _a.state) === 'recording') {
                mediaRecorder.value.stop();
                isRecord.value = false;
            }
        };
        var removeListeners = function () {
            document.removeEventListener('mousemove', mouseMoveAfterRecordStart);
            document.removeEventListener('mouseup', mouseUpAfterRecordStart);
            document.removeEventListener('touchmove', touchMoveAfterRecordStart);
            document.removeEventListener('touchend', touchEndAfterRecordStart);
        };
        var visualize = function (stream) {
            var source = AudioContextWrapper.getInstance().audioContext.createMediaStreamSource(stream);
            var analyser = AudioContextWrapper.getInstance().audioContext.createAnalyser();
            analyser.fftSize = 2048;
            var bufferLength = analyser.frequencyBinCount;
            var dataArray = new Uint8Array(bufferLength);
            source.connect(analyser);
            var step = 255 / 20;
            var draw = function () {
                requestId = requestAnimationFrame(draw);
                analyser.getByteFrequencyData(dataArray);
                var frequencySum = dataArray.reduce(function (previousValue, currentValue) { return previousValue + currentValue; }, 0);
                // 0...255
                var average = Math.ceil(frequencySum / dataArray.length);
                frequency.value.push(average);
                volumePx.value = ((frequencySum / bufferLength) / step) * 15 + 40;
            };
            draw();
        };
        // ДЛЯ ТЕСТА МОБИЛЫ В DEVTOOLS, ОТКЛЮЧАЕТ КОНТЕКСТНОЕ МЕНЮ
        // window.addEventListener("contextmenu", function (e) {
        //     e.preventDefault()
        // })
        __expose({
            manualStop: manualStop
        });
        return function (_ctx, _cache) {
            var _component_e_button = _resolveComponent("e-button");
            var _directive_touch = _resolveDirective("touch");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[
                        isRecord.value && 'e-record-audio--record'
                    ], "e-record-audio-wrapper"])
            }, [
                _createElementVNode("div", {
                    style: _normalizeStyle({
                        width: "".concat(volumePx.value, "px"),
                        height: "".concat(volumePx.value, "px"),
                    }),
                    class: "e-record-audio__background"
                }, null, 4),
                _withDirectives((_openBlock(), _createBlock(_component_e_button, {
                    class: "e-record-audio absolute z-10",
                    type: "text",
                    "disabled-context-menu": "",
                    onMousedown: recordAudioDesktop,
                    onMouseup: showWarningOnClick,
                    onTouchend: showWarningOnClick
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(EIcon, {
                            class: "w-5 h-5",
                            icon: "micro"
                        })
                    ]; }),
                    _: 1
                })), [
                    [_vShow, !__props.retention],
                    [_directive_touch, recordAudioMobile, "hold"]
                ]),
                _withDirectives(_createVNode(_component_e_button, {
                    class: "e-record-audio absolute z-10",
                    type: "text",
                    onClick: send
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(EIcon, {
                            class: "w-5 h-5",
                            icon: "send"
                        })
                    ]; }),
                    _: 1
                }, 512), [
                    [_vShow, __props.retention]
                ])
            ], 2));
        };
    }
});
